import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

//get user not in Group
export const getUserNotInGroupData = createAsyncThunk('getUserNotInGroup/getUserNotInGroupData', async (value) => {
  const response = await axios.get(
    `GetADDetails/GetUsersInExceptGroup?FQDN=${value.fqdn}&groupName=${encodeURIComponent(value.groupName)}&ouName=${
      value.ouName
    }`
  );
  return response.data;
});

const initialState = {
  userNotInGroupLoading: false,
  userNotInGroup: [],
  error: null,
};

const getUserNotInGroupSlice = createSlice({
  name: 'getUserNotInGroupData',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getUserNotInGroupData.pending, (state) => {
        state.userNotInGroupLoading = true;
      })
      .addCase(getUserNotInGroupData.fulfilled, (state, action) => {
        state.userNotInGroupLoading = false;
        state.userNotInGroup = action.payload;
        state.error = null;
      })
      .addCase(getUserNotInGroupData.rejected, (state, action) => {
        state.userNotInGroupLoading = false;
        state.userNotInGroup = [];
        state.error = action.error.message;
      });
  },
});
export default getUserNotInGroupSlice.reducer;
